import { Action } from '@ngrx/store';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel } from "../../shared/interfaces/CriteriaModel";

export enum ActionTypes {
    GetAllItemCategory = 'GetAllItemCategory',
    GetAllItemCategorySuccess = 'GetAllItemCategorySuccess',
    GetAllItemCategoryError = 'GetAllItemCategoryError',

    GetAllCollectionType = 'GetAllCollectionType',
    GetAllCollectionTypeSuccess = 'GetAllCollectionTypeSuccess',
    GetAllCollectionTypeError = 'GetAllCollectionTypeError',

    GetAllProductType = 'GetAllProductType',
    GetAllProductTypeSuccess = 'GetAllProductTypeSuccess',
    GetAllProductTypeError = 'GetAllProductTypeError',

    GetAllOccasionType = 'GetAllOccasionType',
    GetAllOccasionTypeSuccess = 'GetAllOccasionTypeSuccess',
    GetAllOccasionTypeError = 'GetAllOccasionTypeError',

    GetFestiveOccasionName = 'GetFestiveOccasionName',
    GetFestiveOccasionNameSuccess = 'GetFestiveOccasionNameSuccess',
    GetFestiveOccasionNameError = 'GetFestiveOccasionNameError',

    GetAllFestiveOccasionItems = 'GetAllFestiveOccasionItems',
    GetAllFestiveOccasionItemsSuccess = 'GetAllFestiveOccasionItemsSuccess',
    GetAllFestiveOccasionItemsError = 'GetAllFestiveOccasionItemsError',
}

export class GetAllItemCategory implements Action {
    readonly type = ActionTypes.GetAllItemCategory;

    constructor(public payload: CriteriaModel) {
    }
}

export class GetAllItemCategorySuccess implements Action {
    readonly type = ActionTypes.GetAllItemCategorySuccess;

    constructor(public payload: any) {
    }
}

export class GetAllItemCategoryError implements Action {
    readonly type = ActionTypes.GetAllItemCategoryError;

    constructor(public payload: AusmitError) {
    }
}

export class GetAllCollectionType implements Action {
    readonly type = ActionTypes.GetAllCollectionType;

    constructor(public payload: CriteriaModel) {
    }
}

export class GetAllCollectionTypeSuccess implements Action {
    readonly type = ActionTypes.GetAllCollectionTypeSuccess;

    constructor(public payload: any) {
    }
}

export class GetAllCollectionTypeError implements Action {
    readonly type = ActionTypes.GetAllCollectionTypeError;

    constructor(public payload: AusmitError) {
    }
}

export class GetAllProductType implements Action {
    readonly type = ActionTypes.GetAllProductType;

    constructor(public payload: CriteriaModel) {
    }
}

export class GetAllProductTypeSuccess implements Action {
    readonly type = ActionTypes.GetAllProductTypeSuccess;

    constructor(public payload: any) {
    }
}

export class GetAllProductTypeError implements Action {
    readonly type = ActionTypes.GetAllProductTypeError;

    constructor(public payload: AusmitError) {
    }
}

export class GetAllOccasionType implements Action {
    readonly type = ActionTypes.GetAllOccasionType;

    constructor(public payload: CriteriaModel) {
    }
}

export class GetAllOccasionTypeSuccess implements Action {
    readonly type = ActionTypes.GetAllOccasionTypeSuccess;

    constructor(public payload: any) {
    }
}

export class GetAllOccasionTypeError implements Action {
    readonly type = ActionTypes.GetAllOccasionTypeError;

    constructor(public payload: AusmitError) {
    }
}

export class GetFestiveOccasionName implements Action {
    readonly type = ActionTypes.GetFestiveOccasionName;

    constructor(public payload: any) {
    }
}

export class GetFestiveOccasionNameSuccess implements Action {
    readonly type = ActionTypes.GetFestiveOccasionNameSuccess;

    constructor(public payload: any) {
    }
}

export class GetFestiveOccasionNameError implements Action {
    readonly type = ActionTypes.GetFestiveOccasionNameError;

    constructor(public payload: AusmitError) {
    }
}

export class GetAllFestiveOccasionItems implements Action {
    readonly type = ActionTypes.GetAllFestiveOccasionItems;

    constructor(public payload: any) {
    }
}

export class GetAllFestiveOccasionItemsSuccess implements Action {
    readonly type = ActionTypes.GetAllFestiveOccasionItemsSuccess;

    constructor(public payload: any) {
    }
}

export class GetAllFestiveOccasionItemsError implements Action {
    readonly type = ActionTypes.GetAllFestiveOccasionItemsError;

    constructor(public payload: AusmitError) {
    }
}

export type Actions =
    | GetAllItemCategory
    | GetAllItemCategorySuccess
    | GetAllItemCategoryError
    | GetAllCollectionType
    | GetAllCollectionTypeSuccess
    | GetAllCollectionTypeError
    | GetAllProductType
    | GetAllProductTypeSuccess
    | GetAllProductTypeError
    | GetAllOccasionType
    | GetAllOccasionTypeSuccess
    | GetAllOccasionTypeError
    | GetFestiveOccasionName
    | GetFestiveOccasionNameSuccess
    | GetFestiveOccasionNameError
    | GetAllFestiveOccasionItems
    | GetAllFestiveOccasionItemsSuccess
    | GetAllFestiveOccasionItemsError;
